<script>
  import GradientBox from "./GradientBox.svelte";
  import {previewUrlForVideo} from "./services/imageService";
  import {authStore, progressStore} from "./stores/authStore";
  import {getNextData} from "./stores/next_up_store";
  import {onDestroy} from "svelte";
  import VideoLink from "./VideoLink.svelte";

  let nextUp = {};
  const unsubscribe = progressStore.subscribe((u) => {
    const last = u.last;
    if (last && (last.category || last.playlist || last.project)) {
      nextUp = getNextData(last);
    }
  });

  onDestroy(() => {
    unsubscribe();
  })
</script>

{#if $authStore.loggedIn && nextUp.nextVideo}
  <GradientBox>
    <div class="vec-pt-4 vec-rounded vec-shadow ">
      <div class="md:vec-flex">
        <div class="md:vec-w-1/2 vec-p-4">
          <span class="vec-text-3xl vec-font-semibold "
          >Keep Going ...</span
          >
          <div class="vec-mt-4">
            Carry on with the next video
          </div>
        </div>
        <div class="md:vec-w-1/2 vec-p-4">
          <VideoLink video={nextUp.nextState.video} playlist={nextUp.nextState.playlist}
                     project={nextUp.nextState.project} category={nextUp.nextState.category}
          >
            <img
              src={
previewUrlForVideo(nextUp.nextVideo)}
              alt=""
              class="img-fluid rounded"
            />
            <div class="vec-text-2xl vec-mt-3">{nextUp.nextVideo.videoTitle}</div>
            <p class="vec-mt-3">{nextUp.nextVideo.shortDescription}</p>
          </VideoLink>
        </div>

      </div>
    </div>
  </GradientBox>
{/if}
